import { render, staticRenderFns } from "./imcoder-tinymce.vue?vue&type=template&id=60b0ae38&"
import script from "./imcoder-tinymce.vue?vue&type=script&lang=js&"
export * from "./imcoder-tinymce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports